export const DATE_FORMATS = {
  STRING_MONTH: 'DD MMM YYYY',
  DATE: 'YYYY MM DD',
  DATE_WITH_SEPARATOR: 'YYYY-MM-DD',
  DAY: 'DD MMM',
  HOURS_AND_SECS: 'HH:mm',
  YEAR_MONTH: 'YYYY-MM',
  FULL_DATE: 'DD-MM-YYYY',
}
